import { render, staticRenderFns } from "./tradeOrderCommissionPart.vue?vue&type=template&id=08b7325c&scoped=true&"
import script from "./tradeOrderCommissionPart.vue?vue&type=script&lang=js&"
export * from "./tradeOrderCommissionPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7325c",
  null
  
)

export default component.exports